import { render } from "./BannerProp.vue?vue&type=template&id=56e65ddc&scoped=true"
import script from "./BannerProp.vue?vue&type=script&lang=js"
export * from "./BannerProp.vue?vue&type=script&lang=js"

import "./BannerProp.vue?vue&type=style&index=0&id=56e65ddc&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e65ddc"]])

export default __exports__